module.exports = __webpack_public_path__ + "static/media/Communications.66c288be.svg";